import { ControlledDatePicker } from '@@viewCommonComponents/controlled';
import { dateHasConstraints, parseDate } from '@@viewHelpers/validations/index.js';
import { birthdateFromAge } from '@@serverHelpers/index.mjs';
import { useEffect } from 'react';
import getExtraLimitsAge from '../../../simulationCustomerGrantees/client/extra/getExtraAgeLimits';
import moment from 'moment';

const GranteeBirthDate = ({
  granteeIsChild,
  getFieldsName,
  form,
  disabled,
  getMiddleNumber,
  getMiddleText,
  getMiddleBoolean,
  effectDate,
  ...props
}) => {
  const parsedEffectDate = parseDate(effectDate);
  const today = moment().endOf('day');

  // child
  const minChildAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_CHILD');
  const maxChildAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_CHILD');
  let maxChildBirthDate = today.clone();
  if (minChildAge > -1) {
    const calculatedMax = birthdateFromAge(
      minChildAge,
      parsedEffectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
    if (calculatedMax?.isValid()) {
      maxChildBirthDate = moment.min(calculatedMax, today);
    }
  }
  let minChildBirthDate = null;
  if (maxChildAge > -1) {
    const calculatedMin = birthdateFromAge(
      maxChildAge,
      parsedEffectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
    if (calculatedMin?.isValid()) {
      minChildBirthDate = calculatedMin;
    }
  }

  // spouse
  const { minSpouseAge, maxSpouseAge, spouseAgeInfoText } = getExtraLimitsAge(
    getMiddleNumber,
    getMiddleText
  );

  let maxSpouseBirthDate = today.clone();
  if (minSpouseAge > -1) {
    const calculatedMax = birthdateFromAge(
      minSpouseAge,
      parsedEffectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
    if (calculatedMax?.isValid()) {
      maxSpouseBirthDate = moment.min(calculatedMax, today);
    }
  }
  let minSpouseBirthDate = null;
  if (maxSpouseAge > -1) {
    const calculatedMin = birthdateFromAge(
      maxSpouseAge,
      parsedEffectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
    if (calculatedMin?.isValid()) {
      minSpouseBirthDate = calculatedMin;
    }
  }

  const getRules = (
    isChild,
    minGranteeBirthDate,
    maxGranteeBirthDate,
    minGranteeAge,
    maxGranteeAge
  ) =>
    dateHasConstraints(
      minGranteeBirthDate,
      maxGranteeBirthDate,
      getMiddleText(
        `BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_${isChild ? 'CHILD' : 'SPOUSE'}_INFO`,
        {
          minGranteeAge
        }
      ),
      getMiddleText(
        `BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_${isChild ? 'CHILD' : 'SPOUSE'}_INFO`,
        {
          maxGranteeAge
        }
      ),
      isChild
        ? getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_AGE_CHILD_INFO', {
          minGranteeAge,
          maxGranteeAge
        })
        : spouseAgeInfoText,
      getMiddleBoolean('BENEFICIAIRE_DATE_NAISSANCE_EST_OBLIGATOIRE')
    );

  const rulesSpouse = getRules(
    false,
    minSpouseBirthDate,
    maxSpouseBirthDate,
    minSpouseAge,
    maxSpouseAge
  );
  const rulesChild = getRules(true, minChildBirthDate, maxChildBirthDate, minChildAge, maxChildAge);

  let childToolTipCode = null;

  if (minChildAge > -1 && maxChildAge > -1) {
    childToolTipCode = 'BENEFICIAIRE_DATE_NAISSANCE_AGE_CHILD_INFO';
  } else if (minChildAge > -1) {
    childToolTipCode = 'BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_CHILD_INFO';
  } else if (maxChildAge > -1) {
    childToolTipCode = 'BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_CHILD_INFO';
  }
  const childToolTip = getMiddleText(childToolTipCode, {
    minGranteeAge: minChildAge,
    maxGranteeAge: maxChildAge
  });

  useEffect(() => {
    form.clearErrors(getFieldsName('birthDate'));
    form.trigger(getFieldsName('birthDate'));
  }, [granteeIsChild]);

  return (
    <>
      {granteeIsChild ? (
        <ControlledDatePicker
          name={getFieldsName('birthDate')}
          label={getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_LABEL')}
          tooltip={childToolTip}
          form={form}
          minDate={minChildBirthDate?.toDate()}
          maxDate={maxChildBirthDate?.toDate()}
          rules={rulesChild}
          disabled={disabled}
          {...props}
        />
      ) : (
        <ControlledDatePicker
          name={getFieldsName('birthDate')}
          label={getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_LABEL')}
          form={form}
          minDate={minSpouseBirthDate?.toDate()}
          maxDate={maxSpouseBirthDate?.toDate()}
          rules={rulesSpouse}
          disabled={disabled}
          {...props}
        />
      )}
    </>
  );
};

export default GranteeBirthDate;
